import React, { Component } from 'react';
import * as constants from '../constants';
import Dropzone from 'react-dropzone';
import axios from 'axios';
import { loadProgressBar } from 'axios-progress-bar';
import dateformat from 'dateformat';
import { URL_API_S3SIGNER, URL_API_LISTS3BUCKET } from '../Utils';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'; // https://allenfang.github.io/react-bootstrap-table/index.html
import { PageHeader, Fade, ListGroup } from 'react-bootstrap';

import {CopyToClipboard} from 'react-copy-to-clipboard';

const IMAGE_MAX_WIDTH  = 600;
const IMAGE_MAX_HEIGHT = 300;

const headerStyle = {
    textAlign: 'center'
};


const calculateAspectRatioResize = (srcWidth, srcHeight) => {
    const ratio = IMAGE_MAX_WIDTH / srcWidth; // we go by width
    return { width: Math.round(srcWidth*ratio), height: Math.round(srcHeight*ratio) };
};

const HrefField = ({onChange}) => {
    return (
        <div style={{ float: 'left' }}>
            <label for="imghref">Image link:</label>{' '}
            <input id="imghref" type="text" onBlur={onChange}/>{' '}<button>add link</button>
        </div>
    )
};

const CaptionField = ({onChange}) => {
    return (
        <div style={{ float: 'left' }}>
            <label for="imgCaption">Image caption:</label>{' '}
            <input id="imgCaption" type="text" onBlur={onChange}/>{' '}<button>add caption</button>
        </div>
    )
};


const IconOK = () => {
        return (
            <div className="dropzone-center ok">
                <i style={{color: '#7AC450'}} className="fa fa-check-square-o fa-5x" aria-hidden="true"></i>
            </div>
        )
};

const IconNotOK = () => {
    return (
        <div className="dropzone-center notOk">
            <i style={{color: '#b90000'}} className="fa fa-times fa-5x" aria-hidden="true"></i>
        </div>
    )
};

class ImageEmbed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scaledImg: calculateAspectRatioResize(props.width, props.height),
            href: '',
            caption: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            href: nextProps.href,
            caption: nextProps.caption,
            scaledImg: calculateAspectRatioResize(nextProps.width, nextProps.height)
        });
    }

    render = () => {
        const val =
            `<div style="padding: 20px; font-size:80%; text-align:center;" width="${this.state.scaledImg.width}" height="${this.state.scaledImg.height}">\n` +
            `<a href="${this.props.href}">\n` +
            `<img style="display: block; margin-left: auto; margin-right: auto; padding-bottom: 0.5em" src="https://s3.amazonaws.com/bestmediafiles/${encodeURIComponent(this.props.fileName)}" alt="" width="${this.state.scaledImg.width}" height="${this.state.scaledImg.height}" />\n` +
            `</a>\n`+
            `${this.props.caption || ''}`+
            `</div>`;
        this.props.handler(val);
        return (
            <textarea readOnly value={val} />
        )
    };
};

const PDfEmbed = pdf => {
    const val=`<style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><object data="https://s3.amazonaws.com/bestmediafiles/${encodeURIComponent(pdf.fileName)}" type="application/pdf" height="800" width="600"></object></div>`
    pdf.handler(val);
    return (
        <textarea readOnly value={val} />
    )
};

const AudioEmbed = audio => {
    // const val=`<style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src='${encodeURIComponent(pdf.fileName)}' frameborder='0' allowfullscreen></iframe></div>`;
    // vid.handler(val);
    // return (
    //     <textarea onChange={this.onChange} value={val} />
    // )
};

const VideoEmbed = vid => {
    const val=`<style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src="https://s3.amazonaws.com/bestmediafiles/${encodeURIComponent(vid.fileName)}" frameborder='0' allowfullscreen></iframe></div>`;
    vid.handler(val);
    return (
        <textarea readOnly value={val} />
    )
};

class ImageThatDisappearsOnError extends Component {

    state = { errored: false};

    handleError = evt => {
        this.setState({errored: true});
    };

    render() {
        return this.state.errored ? <img width="60" height="60" src='https://s3.amazonaws.com/blogmanagement-hosting-mobilehub-1183121982/public/img/no_image_transp.png' /> : <img onError={this.handleError} src={this.props.src} />;
    }
}

const fileExtensionMap = new Map();
fileExtensionMap.set('.jpg', { type: constants.IMAGE, contentType: 'image/jpeg' });
fileExtensionMap.set('.gif', { type: constants.IMAGE, contentType: 'image/gif' });
fileExtensionMap.set('.png', { type: constants.IMAGE, contentType: 'image/png' });
fileExtensionMap.set('.mp4', { type: constants.VIDEO, contentType: 'video/mp4' });
fileExtensionMap.set('.mp3', { type: constants.AUDIO, contentType: 'audio/mpeg3' });
fileExtensionMap.set('.pdf', { type: constants.PDF,   contentType: 'application/pdf' });

export default class S3Uploader extends Component {
    constructor(props) {
        super(props);
        this.setMediaVal = this.setMediaVal.bind(this);
        this.getMediaPanel = this.getMediaPanel.bind(this);
        this.getFileType   = this.getFileType.bind(this);
        this.getFileExt = this.getFileExt.bind(this);
        loadProgressBar();

        this.state = {
            accessToken: props.userToken,
            value: '',
            copied: false,
            valToCopy: '',
            currentImgHref: '',
            imgHref: '',
            fadeOut: false,
            visibility: 'visible',
            bucketObjects: []
        };
    };

    async componentDidMount() {
        if(this.props.userToken === null) {
            return;
        }
        await this.loadBucketObjects();
    }

    async loadBucketObjects() {
        this.setState({isLoading: true});

        try {
            const results = await this.bucketObjects();
            this.setState({bucketObjects: results.data.body});
        }
        catch (e) {
            alert(e);
        }

        this.setState({isLoading: false});
    }

    bucketObjects = () => {
        return axios.get(`${URL_API_LISTS3BUCKET}`)
    };

    setMediaVal = newVal => {
        if(this.state.valToCopy !== newVal) {
            this.setState({
                valToCopy: newVal
            });
        }
    };

    getMediaPanel = () => {
        switch(this.state.fileType) {
            case constants.IMAGE:
                return <ImageEmbed href={this.state.currentImgHref} caption={this.state.currentImgCaption} handler={this.setMediaVal} fileName={ this.state.s3File.name } width={ this.state.imgWidth } height={ this.state.imgHeight }/>
            case constants.PDF:
                return <PDfEmbed handler={this.setMediaVal} fileName={ this.state.s3File.name } />
            case constants.AUDIO:
                return;
            case constants.VIDEO:
                return <VideoEmbed handler={this.setMediaVal} fileName={ this.state.s3File.name } />

        }
    };

    getFileExt = fileName => {
        const ext = fileName.match(/\.[0-9A-Za-z]+$/);
        return ext ? ext[0].toLowerCase() : '';
    };

    getFileType = fileExt => {
        return fileExtensionMap.get(fileExt);
    };

    getImgParams = res => {
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.onload = () => {
                this.setState({
                    base64res: res,
                    imgWidth: img.width,
                    imgHeight: img.height
                });
                resolve(img);
            };
            img.onerror = reject;
            img.src = res;
        })
    };

    onDrop = files => {
        const fileName = files[0].name;
        const fileExt = this.getFileExt(fileName);
        const fileType = this.getFileType(fileExt).type;
        const mimeType = this.getFileType(fileExt).contentType;
        this.setState({
            s3File: files[0],
            fileName: fileName,
            fileType: fileType,
            mimeType: mimeType,
            fileExt: fileExt
        }, this.afterDrop);
    };

    afterDrop = () => {
        const allowedFileExtensions = Array.from(fileExtensionMap.keys());

        if(!allowedFileExtensions.includes(this.state.fileExt)) {
            this.setState({
                error: `${this.state.fileExt} is unsupported. Supported file types are: ${allowedFileExtensions.reduce((acc,type) => acc + ', ' + type)}`
            });
            return;
        }
        let url = `${URL_API_S3SIGNER}?fileName=${this.state.fileName}`;

        switch(this.state.fileType)  {
            case constants.IMAGE:
                const preview = window.URL.createObjectURL(this.state.s3File);
                axios.get(preview, { responseType:"blob" })
                    .then( response => {
                        const reader = new window.FileReader();
                        reader.readAsDataURL(response.data);
                        reader.onload = () => {
                            const res = reader.result;
                            this.getImgParams(res).then( obj => {
                                this.signAndPut(url+`&x-amz-meta-height=${obj.height}&x-amz-meta-width=${obj.width}`);
                            });
                        }
                    });
                break;
            case constants.VIDEO:
                this.signAndPut(url);
                break;
            default:
                this.signAndPut(url);
        }
    };

    signAndPut(url) {
        axios.get(url, {headers: {Authorization: this.state.accessToken}}).then(async response => {
            this.putSigneds3Object(response.data);
        });
    }

    putSigneds3Object(putURL) {
        axios.put(putURL, this.state.s3File, {headers: { 'Content-Type': this.state.mimeType}}).then(async response => {
            const bObjects = await this.bucketObjects();
            this.setState({
                statusCode: response.status,
                uploaded: constants.SUCCESS,
                bucketObjects: bObjects.data.body
            });
        }).catch(function (error) {
            const errorStatus = error.response ? error.response.status : '';
            this.setState({
                statusCode: errorStatus,
                uploaded: constants.FAILURE,
            });
        });
    }

    attachDateFormatter = (cell,row) => {
        return dateformat(row.LastModified, 'fullDate');
    };

    addDefaultSrc = ev => {
        ev.target.src = ''
    };

    attachImageFormatter = (cell,row) => {
        return <ImageThatDisappearsOnError src={row.thumbnail} />
    };


    onHrefChange = (evt) => {
        this.setState({ currentImgHref: evt.currentTarget.value });
    };

    onCaptionChange = (evt) => {
        this.setState({ currentImgCaption: evt.currentTarget.value });
    };

    onApplyHrefClick = () => {
        this.setState({
            currentImgHref: this.state.imgHref
        });
    };

    onRowSelect = row => {
        const fileName = row.Key;
        this.setState({
            s3File: {name: row.Key},
            uploaded: constants.NONE,
            fileType: this.getFileType(this.getFileExt(fileName)).type,
            imgWidth: row.width,
            imgHeight: row.height
        });
    };

    render() {
        const bucketList = this.state.bucketObjects.map( obj => {
            const fExt = this.getFileExt(obj.Key);
            const fType = this.getFileType(fExt).type;
            const thumbFile = `thumb-${obj.Key}.png`; //encodeURIComponent(obj.Key+'.png');// : encodeURIComponent(obj.Key);
            return {...obj, fileType: fType, thumbnail: `https://s3.amazonaws.com/bestmediafiles-thumb/${thumbFile}`, width: obj.Metadata.width, height: obj.Metadata.height }
        });
        return (
                <div>
                    <PageHeader style={headerStyle}>Bible.In.Its.Traditions Media Assets</PageHeader>
                    <Dropzone style={{
                        width: "100%",
                        height: 200,
                        border: 'dashed 2px #999',
                        borderRadius: 5,
                        position: 'relative',
                        cursor: 'pointer',
                        overflow: 'hidden'
                    }} onDrop={this.onDrop}>
                        {
                            this.state.s3File && this.state.uploaded === constants.SUCCESS ? <IconOK /> :
                                this.state.uploaded === constants.FAILURE ? <IconNotOK /> :
                                    <div className="dropzone-center text">Drop your files here or click to select one.</div>
                        }
                    </Dropzone>
                    {   this.state.s3File && [constants.NONE, constants.SUCCESS].includes(this.state.uploaded) ?
                        <div>
                            <section className="section">
                                { this.getMediaPanel() }
                            </section>
                            <div>
                            <table cellpadding="10" width="100%">
                            <tr><td>
                            { this.state.fileType === constants.IMAGE ? <HrefField onChange={this.onHrefChange}/> : '' }
                            </td><td>
                            { this.state.fileType === constants.IMAGE ? <CaptionField onChange={this.onCaptionChange}/> : '' }
                            </td><td>
                            <div style={{ 'text-align': 'right', width: '100%' }}>
                            <CopyToClipboard text={this.state.valToCopy}
                                             onCopy={() => this.setState({copied: true, open: true}, () => {
                                                 window.setTimeout(() => {
                                                 this.setState({
                                                     copied: false,
                                                     open: false
                                                 });
                                             }, 3000);} )}>
                                <button >Copy to clipboard</button>
                            </CopyToClipboard>
                            </div>
                            { this.state.copied === true ?
                                <div style={{ 'text-align': 'right', width: '100%' }}>
                                <Fade in={this.state.open} timeout={1000}>
                                    <span style={{'color': '#7AC450', 'fontWeight': 'bold', 'paddingLeft': '30px' }}>copied to clipboard!</span>
                                </Fade>
                                </div>
                                 : ''
                            }
                            </td></tr></table>
                            </div>
                        </div>
                        : ''
                    }
                    { this.state.error ? <span style={{'color': 'red', 'font-weight': 'bold'}}>{this.state.error}</span>: '' }
                    <div style={{ padding: '20px', clear: 'both' }}>
                        <BootstrapTable pagination
                                        search
                                        selectRow={ {
                                            mode: 'radio',
                                            clickToSelect: true,  // click to select, default is false
                                            onSelect: this.onRowSelect
                                        } }
                                        options={ { defaultSortName: 'LastModified', defaultSortOrder: 'desc'} }
                                        data={ bucketList }
                                        striped
                                        hover>
                            <TableHeaderColumn isKey width="70" dataField='ETag' hidden autoValue></TableHeaderColumn>
                            <TableHeaderColumn dataField='Key' columnTitle>Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='thumbnail' tdStyle={ { textAlign: 'center' } } dataFormat={this.attachImageFormatter.bind(this)} columnTitle>Thumbnail</TableHeaderColumn>
                            <TableHeaderColumn dataField='fileType' width="70" columnTitle>Type</TableHeaderColumn>
                            <TableHeaderColumn dataField='LastModified' dataFormat={this.attachDateFormatter.bind(this)} dataSort columnTitle>Upload Time</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
        );
    };
};



// WEBPACK FOOTER //
// ./src/containers/S3Uploader.js